// The public "Start a U.S. company" wizard ships as its own single-purpose
// front-end bundle (docker service pexify-app-start-frontend), built with
// VITE_BASE_PATH=/start-company/. In that bundle the TanStack Router basepath is
// "/start-company", so the browser URL /start-company/ resolves to the in-app
// root path "/". The router uses this predicate to mount ONLY the wizard at "/"
// with no auth guard and no app shell — otherwise "/" would match the auth-gated
// index landing and bounce the anonymous applicant to /login. It is always false
// in the main app build (base "/m0/", "/app/", "/admin/", …), so that build's
// behaviour and route types are unchanged. See router.tsx.
export function isStartCompanyBundle(
  baseUrl: string = import.meta.env.BASE_URL,
): boolean {
  return baseUrl === '/start-company/'
}
